export var GAActions = {
  PRIMARY_NAV: 'Primary Nav',
  MOBILE_MENU: 'Mobile Menu',
  MOBILE_HEADER: 'Mobile Header',
  SEARCH_POPUP: 'Search Popup'
};
export var GALabels = {
  SCHOOL_SEARCH: 'School Search',
  PROJECT_SEARCH: 'Project Search',
  ADDRESS_SEARCH: 'Address Search'
};